import * as React from 'react';
import { withRouter } from 'next/router';
import { withStyles, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';

import combineStyles from '../../../styles/combineStyles';
import { buttonStyles } from '../../../styles/base';
import * as types from '../../../actions/actionTypes';
import ShowingsColumn from '../../utility/ShowingsCalendar/ShowingsColumn';
import styles from './styles';
import { extractAvailableOpenHouses } from '../../../lib/helpers';

const ShowingsCalendar = dynamic(() =>
  import('../../utility/ShowingsCalendar'),
);

interface Props {
  classes: any;
  containerHeight: number;
  dispatch: any;
  listing: any;
  openHouses: any;
  router: any;
  showings: any;
  token: string;
}

interface State {
  scheduledShowing: any;
  showingScheduled: boolean;
}

export class Tour extends React.Component<Props, State> {
  state = {
    scheduledShowing: undefined as any,
    showingScheduled: false,
  };

  componentDidMount() {
    this.checkStatus();
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.showings.length !== this.props.showings.length) {
      this.checkStatus();
    }
  }

  checkStatus = () => {
    const { listing, showings } = this.props;
    if (showings) {
      showings.find((showing: any) => {
        if (showing.listingId === listing.id) {
          this.setState({
            scheduledShowing: showing,
            showingScheduled: true,
          });
        }
      });
    }
  };

  handleLoginClick = () => {
    this.props.dispatch({
      postAuthPath: '',
      signupSubtext: `Sign up to easily schedule a time to see a home in-person. Manage and receive updates on your showings.`,
      type: types.OpenSignupDialog,
    });
  };

  render() {
    const { classes, containerHeight, showings, token, listing } = this.props;
    const availableOpenHouses = extractAvailableOpenHouses(
      showings,
      listing.openHouses,
      listing.id,
    );
    return (
      <React.Fragment>
        {!token ? (
          <div className={classes.loginButtonContainer}>
            <Button
              className={classes.buttonLargeBlue}
              type="submit"
              variant="contained"
              onClick={this.handleLoginClick}
            >
              LOGIN / SIGNUP
            </Button>
          </div>
        ) : (
          <div className={classes.tourWrapper}>
            <ShowingsColumn key={showings.length} showings={showings} />
            <div className={classes.tourContainer}>
              <ShowingsCalendar
                listing={listing}
                containerHeight={containerHeight}
                openHouses={availableOpenHouses}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const combinedStyles = combineStyles(buttonStyles, styles);

const mapStateToProps = (state: any) => ({
  openHouses: state.listings.openHouses,
  showings: state.showings.showings,
  token: state.auth.token,
});

export default connect(mapStateToProps)(
  withStyles(combinedStyles)(withRouter(Tour)),
);
